/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package tables.presentation.common.model

enum class DayNumberOption {
    ALL,
    N1,
    N2,
    N3,
    N4,
    N5,
    N6,
    N7
}